import React, { Component } from 'react'
import { TextField, FormControl } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class DefDossierDefFieldAutoIncrementSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prefix:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.prefix
                    ? this.props.item.settings.prefix
                    : null,
        }
    }

    render() {
        const { kedo, onChange } = this.props
        const { prefix } = this.state
        return (
            <div>
                <h5>{kedo.t('Additional settings')}</h5>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {this.props.kedo.t('Prefix')}
                    </FormInputLabel>
                    <TextField
                        value={prefix}
                        onChange={(e) => {
                            const newValue = e.target.value
                            this.setState({ prefix: newValue })
                            // delay update to parent, as in original code
                            setTimeout(() => onChange('prefix', newValue), 50)
                        }}
                        size="small"
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefDossierDefFieldAutoIncrementSettings
